/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { unescapeHtml,escapeHtml,ChangeSearchingDateFormat } from "../../components/common/Common";

import "../../css/style.css";

const QuestionDetail = () => {
  const mem_idx = localStorage.getItem("mem_idx");
  const navigate = useNavigate();
  //공지사항 
  const [varBoardData,setBoardData] = useState({});

  //게시판 변수 저장 객체
  const newData = {      
    board_idx: 0,
    answer_idx: 0,
    quest_idx: mem_idx,
    board_title: "",
    board_comment: "",
    board_answer: "",
    board_rdate: ChangeSearchingDateFormat(new Date(),'.'),
    board_adate: "",
    board_hits: 0,
    board_status:1
  };

  //공지사항정보 읽어오기
  const registerQuestionHandler = async () => {
    const sendData = {dataInfo:varBoardData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_register_question_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate(`/Question`);
      }
    });
  }
  //최초실행부
  useEffect(() => {
    setBoardData(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    setBoardData({...varBoardData,[name]:escapeHtml(value)});
  }

  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'1:1문의하기'}/>
        <div className="vh-content-body">
          <div className="form-group mb10">
            <label className="form-label">제목</label>
            <div className="field-group">
              <input type="text" name="board_title" className="form-control" value={unescapeHtml(varBoardData.board_title)} onChange={onChangeInputHandler}/>
            </div>
          </div>
          <div className="form-group mb10">
            <label className="form-label">문의내용</label>
            <div className="field-group">
              <textarea name="board_comment" className="form-control" value={unescapeHtml(varBoardData.board_comment)} onChange={onChangeInputHandler}/>
            </div>
          </div>
          <div className="form-contoller flex-vertical">
            <button className="form-contoller-btn" onClick={e=>registerQuestionHandler(e)}>문의하기</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default QuestionDetail;